<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="column screen-width" style="gap: 40px; padding: 60px 0px">
            <p style="font-size: 32px; font-weight: bold">로그인</p>

            <div class="login-view align-center column">
                <!-- <div class="logo-view">
        <v-img :src="marineplay_logo" height="300"> </v-img>
      </div> -->

                <div class="input-user column align-center">
                    <input
                        v-model="email"
                        class="input-form"
                        type="text"
                        placeholder="아이디(email)"
                        @click="target = 0"
                    />

                    <input
                        v-model="password"
                        class="input-form"
                        type="password"
                        placeholder="비밀번호"
                        @click="target = 1"
                    />
                </div>

                <div class="button">
                    <v-btn color="info" width="600" height="70%" @click="login">
                        로그인
                    </v-btn>
                </div>

                <div
                    class="row align-space-between"
                    style="width: 600px; gap: 16px"
                >
                    <router-link :to="'/signup'" class="align-center" style="flex: 1; color:black">
                        <p style="font-size: 16px; font-weight: bold">
                            회원가입
                        </p>
                    </router-link>
                    <router-link :to="'/find/id'"  class="align-center" style="flex: 1; color:black">
                        <p style="font-size: 16px; font-weight: bold">
                            계정 ID 찾기
                        </p>
                    </router-link>
                    <router-link :to="'/find/password'" class="align-center" style="flex: 1; color:black">
                        <p style="font-size: 16px; font-weight: bold">
                            비밀번호 찾기
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import marineplay_logo from "@/assets/marineplay_logo.png";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref } from "vue";

export default {
    components: {},
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        const email = ref("");
        const password = ref("");
        const target = ref(0);
        const inputId = ref(false);
        const inputPassword = ref(false);

        const setLogin = (type, value) => {
            if (type === "id") {
                email.value = value;
            } else if (type === "password") {
                password.value = value;
            }
        };

        const login = async () => {
            var userInfo = {
                email: null,
                password: null,
            };

            if (email.value !== null || password.value !== null) {
                userInfo.email = email.value;
                userInfo.password = password.value;
                await store
                    .dispatch("loginUser", userInfo)
                    .then(() => {
                        router.replace({ path: "/home" }); // 로그인 성공 후 홈으로 리디렉션
                    })
                    .catch((error) => {
                        console.log(error);
                        alert("아이디나 비밀번호를 다시 한번 확인해주세요");
                    });
            } else {
                alert("아이디와 비밀번호는 입력해주세요");
            }
        };

        const sendEvent = () => {
            emit("login");
        };

        return {
            marineplay_logo,
            login,
            email,
            password,
            inputId,
            sendEvent,
            setLogin,
            inputPassword,
            target,
        };
    },
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: relative;
    z-index: 1;
}
.container::after {
    content: "";
    width: 25%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: absolute;
    /* background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ),
    url(@/assets/background_img.jpg); */
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
    opacity: 0.6;
}
.login-view {
    width: 100%;
    height: 500px;
    background: white;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}

.logo-view {
    width: 100%;
    text-align: center;
    height: 45%;
}

.input-user {
    width: 600px;
    text-align: center;
    height: 240px;
}

.input-form {
    width: 600px;
    border: 1px solid black;
    height: 80px;
    margin: 10px;
    text-indent: 15px;
}

.button {
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
}
</style>
